<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">
				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
						<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
							<div>
								<h2 class="text-white pb-2 fw-bold">Master Puskesmas</h2>
							</div>
							<div class="ml-md-auto py-2 py-md-0">
								<div class="form-group">
									<div class="input-group">
										<input v-model="cari_value" @keyup="cari_data()" type="text" class="form-control" placeholder="Cari data ...">
										<div class="input-group-append">
											<button @click="Get_Add()" class="btn btn-primary" type="button" title="Tambah Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
<!-- <h1>TES1</h1>

<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">

                        <table class="table-kiken table table-head-bg-info" width="100%" >
                            <thead>
                                <tr class="bg-primary">
                                    <th scope="col" style="width: 5%">No</th>
                                    <th scope="col" style="width: 12%">Kode Pangan Kec</th>
                                    <th scope="col" style="width: 12%">Kode Desa/Kel.</th>
                                    <th scope="col" style="width: 56%">Nama Desa/Kelurahan</th>
                                    <th scope="col" style="width: 15%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="cek_load_data">
                                    <td colspan="9" class="text-center">
                                        <img src="img/loading-plan.gif" width="450px">
                                    </td>
                                </tr>
                                <template v-if="!cek_load_data" >
                                    <tr class="h_isitable" v-for="(data, index ) in list_data" :key="data.des_kel_id">
                                        <td class="text-center">{{index+1}}</td>
                                        <td class="text-center">{{data.kode_pangan_kecamatan}}</td>
                                        <td class="text-center">{{data.kode_pangan}}</td>
                                        <td>{{data.nama_des_kel}}</td>
                                        <td class="text-center">
                                            <!-- <a @click="ke_alamat(data.isi)" class="btn btn-info btn-icon btn-round btn-xs" title="Menuju ke halaman sistem" data-toggle="modal"><i style="color:white" class="fas fa-play-circle"></i></a>
                                            &nbsp; -->
                                            <button @click="selectData(data)" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                            &nbsp;
                                            <button @click="removeData(data.des_kel_id)" class="btn btn-danger btn-icon btn-round btn-xs" title="Hapus Data"><i class="fas fa-trash-alt"></i></button>

                                        </td>
                                    </tr>
                                </template>


                            </tbody>
                        </table>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <img src="assets/img/sf/sign-left.svg" height="24" width="24">
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <img src="assets/img/sf/sign-right.svg" height="24" width="24">
                                </button>
                            </div>
                        <hr>



					</div>

				</div>




                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">
                                        <span class="huruf_input">Provinsi</span>
                                        <autocomplete
                                            :url="URL+ 'api/v1/statistik_ketapang_master_kecamatan/autocomplete'"
                                            :customHeaders="{authorization: 'kikensbatara '+token }"
                                            anchor="nama_kecamatan"
                                            :initValue="''"
                                            :placeholder="'Cari Kecamatan'"
                                            :classes="{ input: 'form-control form-control-sm'}"
                                            label="writer"
                                            :onShouldRenderChild="renderChild"
                                            :on-select="getAuto">
                                        </autocomplete>
                                        <br>

                                        <span class="huruf_input">Kode Desa/Kel</span>
                                        <input v-model="form.kode_des_kel" type="text" class="form-control form-control-sm"> <br>

                                        <span class="huruf_input">Kode Wilayah Pangan</span>
                                        <input v-model="form.kode_pangan" type="text" class="form-control form-control-sm"> <br>

                                        <span class="huruf_input">Nama Desa/Kel</span>
                                        <input v-model="form.nama_des_kel" type="text" class="form-control form-control-sm"><br>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-info btn-md">SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">BATAL</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">EDIT DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div v-if="cek_edit">
                                            <span class="huruf_input">Provinsi</span>
                                            <autocomplete
                                                :url="URL+ 'api/v1/statistik_ketapang_master_kecamatan/autocomplete'"
                                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                                anchor="nama_kecamatan"
                                                :initValue="form.nama_kecamatan"
                                                :placeholder="form.nama_kecamatan"
                                                :classes="{ input: 'form-control form-control-sm'}"
                                                label="writer"
                                                :onShouldRenderChild="renderChild"
                                                :on-select="getAuto">
                                            </autocomplete>
                                            <br>

                                            <span class="huruf_input">Kode Desa/Kel</span>
                                            <input v-model="form.kode_des_kel" type="text" class="form-control form-control-sm"> <br>

                                            <span class="huruf_input">Kode Wilayah Pangan</span>
                                            <input v-model="form.kode_pangan" type="text" class="form-control form-control-sm"> <br>

                                            <span class="huruf_input">Nama Desa/Kel</span>
                                            <input v-model="form.nama_des_kel" type="text" class="form-control form-control-sm"><br>

                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->  
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-header">
                                    <h5 class="modal-title">DATA DETIL</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="text-center">
                                        <span class="h_isitable_bold">{{form.judul}}</span> <br>
                                        <span class="h_cetak11">Tgl. {{convert_tgl(form.createAt)}},  &nbsp; Oleh : {{form.createBy}}</span>
                                    </div>
                                    <hr>
                                    <div class="table-responsive">
                                        <div v-html="form.isi"></div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->




			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/statistik_ketapang_master_des_kel/";
const ADD_URL_KECAMATAN = URL_APP + "api/v1/statistik_ketapang_master_kecamatan/";
const FILE_LOAD = URL_APP + "uploads/";


import Autocomplete from 'vue2-autocomplete-js';
const URL_SERVER = URL_APP;



export default {
    components: { Autocomplete },
    data() {
        return {
            data_load : false,
            form : {
                des_kel_id : '',
                kecamatan_id : '',
                kode_des_kel : '',
                nama_des_kel : '',
                kode_pangan : '',
                nama_kecamatan : '',
            },
            id :'',
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_kabupaten: [],
            list_provinsi: [],
            page_first: 1,
            page_last: 0,
            cari_value: "",

            cek_load_data : true,
            cek_edit : false,

            URL : URL_SERVER,
            token : localStorage.token,
        }
    },
    methods: {
        getView: function() {
            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
            });
        },

        addData: function() {

            fetch(ADD_URL + "addData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
        },

        editData: function() {

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    id: idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },

        selectData: function(data) {

            this.form = {
                des_kel_id : data.des_kel_id,
                kecamatan_id : data.kecamatan_id,
                kode_des_kel : data.kode_des_kel,
                nama_des_kel : data.nama_des_kel,
                kode_pangan : data.kode_pangan,
                nama_kecamatan : data.nama_kecamatan,
            };

            this.cek_edit = true

        },

        Get_Add : function(){

        },

        emptyData : function(){
            this.list_provinsi = [];
            this.cek_edit = false;
        },
        ke_alamat : function(data){
            window.open(data);
        },

    // ================== TAMBAHAN ====================

      


    // ================== TAMBAHAN ====================

    // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${data.nama_kecamatan}</b></span>
            <span style='font-size:80%'>${data.nama_kabupaten}</span>
            `
        },
        getAuto : function(obj){
            this.form.kecamatan_id = obj.kecamatan_id
            console.log(obj);
        },
    // ================== AUTOCOMPLETE ====================


    // ================== PAGINASI ====================
        alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },
    // ================== PAGINASI ====================

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }

        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;

        this.getView();


    },

}
</script>